import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, FileText, LayoutGrid, Rows, Boxes, FileStack, Archive, Plus, Tag } from "lucide-react";

import { getProposalNotificationFeed } from "../api/prospectingReportsApi";

/**
 * Proply-style secondary sidebar for the Proposals workspace, shown inside the
 * CRM shell. Top items (Proposals / Templates / Sections / Inventory +
 * Notifications) mirror Proply so agents moving over aren't confused; when on
 * Proposals it also shows Current / Archived and the agent's labels.
 */
const navItemCls = (active) =>
  `w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold ${
    active ? "text-[#0f8d9b] bg-[#eaf7f8]" : "text-gray-600 hover:bg-gray-50"}`;

const ProposalWorkspaceNav = ({
  active, view, onView, labels = [], activeLabel, onLabel, onAddLabel, onOpenNotifications,
}) => {
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    getProposalNotificationFeed().then(({ data }) => setUnread(data?.unread_count || 0)).catch(() => {});
  }, []);
  return (
    <aside className="w-56 shrink-0 border-r border-gray-100 pr-3">
      <nav className="space-y-1">
        <button type="button" onClick={onOpenNotifications} className={navItemCls(false)}>
          <Bell className="w-4 h-4" /> Notifications
          {unread > 0 && <span className="ml-auto text-[11px] font-bold text-white bg-[#0f8d9b] rounded-full px-1.5">{unread}</span>}
        </button>
        <button type="button" onClick={() => navigate("/prospecting/proposals")} className={navItemCls(active === "proposals")}>
          <FileText className="w-4 h-4" /> Proposals
        </button>
        <button type="button" onClick={() => navigate("/prospecting/proposals/templates")} className={navItemCls(active === "templates")}>
          <LayoutGrid className="w-4 h-4" /> Templates
        </button>
        <button type="button" onClick={() => navigate("/prospecting/proposals/sections")} className={navItemCls(active === "sections")}>
          <Rows className="w-4 h-4" /> Sections
        </button>
        <button type="button" onClick={() => navigate("/collings-properties")} className={navItemCls(false)}>
          <Boxes className="w-4 h-4" /> Inventory
        </button>
      </nav>

      {active === "proposals" && (
        <div className="mt-5 pt-4 border-t border-gray-100 space-y-1">
          <button type="button" onClick={() => onView && onView("current")}
            className={navItemCls(view === "current" && !activeLabel)}>
            <FileStack className="w-4 h-4" /> Current
          </button>
          <button type="button" onClick={() => onView && onView("archived")}
            className={navItemCls(view === "archived")}>
            <Archive className="w-4 h-4" /> Archived
          </button>
          <button type="button" onClick={onAddLabel}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-semibold text-[#0f8d9b] hover:bg-gray-50">
            <Plus className="w-4 h-4" /> Add label
          </button>
          {labels.map((l) => (
            <button key={l.id} type="button" onClick={() => onLabel && onLabel(l)}
              className={navItemCls(activeLabel && activeLabel.id === l.id)}>
              <Tag className="w-4 h-4" style={{ color: l.colour || "#6b7280" }} />
              <span className="truncate">{l.name}</span>
            </button>
          ))}
        </div>
      )}
    </aside>
  );
};

export default ProposalWorkspaceNav;
